if (!window.Eurus.loadedScript.has('recently-viewed.js')) {
  window.Eurus.loadedScript.add('recently-viewed.js');

  /* NZS-ALPINE-BOOT (2026-07-31): run now, not next frame - vendors.js dispatches alpine:init before the next paint, so an rAF-deferred listener randomly loses its registrations. Same fix as theme.js. */(function(_cb){_cb()})(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xProductRecently', {
        show: false,
        fallback: false,
        productsToShow: 0,
        productsToShowMax: 10,
        init() {
          if (document.getElementById('shopify-section-recently-viewed')) {
            this.productsToShow = document.getElementById('shopify-section-recently-viewed').getAttribute("x-products-to-show");
          }
        },
        /* NZS-RV-FALLBACK (Blake 2026-08-01): decide between the real row and the
           Best-sellers fallback. productId is the product being viewed -- a history holding
           only that product yields nothing to show, which used to render a visible empty row. */
        /* NZS-RV-CAP8-R5 (Blake R5): history is capped at 8 on write; slice on read too so a
           longer list already sitting in a returning shopper's localStorage still behaves. */
        usableHistory(productId) {
          let list = [];
          try { list = JSON.parse(localStorage.getItem("recently-viewed") || "[]"); } catch (e) { list = []; }
          if (!Array.isArray(list)) list = [];
          list = list.slice(0, 8);
          return productId ? list.filter(p => p !== productId) : list;
        },
        useFallback() {
          this.show = false;
          this.fallback = true;
        },
        showProductRecently(productId) {
          if (this.usableHistory(productId).length) {
            this.show = true;
            this.fallback = false;
          } else {
            this.useFallback();
          }
        },
        setProduct(productViewed) {
          let productList = [];
          if (localStorage.getItem("recently-viewed")?.length) {
            productList = JSON.parse(localStorage.getItem("recently-viewed")); 
            productList = [...productList.filter(p => p !== productViewed)].filter((p, i) => i<this.productsToShowMax);
            this.show = true;
            /* NZS-RV-CAP8-R5: cap the stored history at 8 before it is persisted. */
            let newData = [productViewed, ...productList].slice(0, 8);
            localStorage.setItem('recently-viewed', JSON.stringify(newData))
          } else {
            this.show = false;
            localStorage.setItem('recently-viewed', JSON.stringify([productViewed]));
          }
        },
        getProductRecently(sectionId, productId) {
          let products = this.usableHistory(productId).slice(0, this.productsToShow);
          if (!products.length) {
            this.useFallback();
            return;
          }
          const el = document.getElementById("shopify-section-recently-viewed");
          let query = products.map(value => "id:" + value).join(' OR ');
          var search_url = `${Shopify.routes.root}search?section_id=${ sectionId }&type=product&q=${query}`;
          fetch(search_url).then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              console.log(error)
              throw error;
            }
    
            return response.text();
          })
          .then((text) => {
            const fetched = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-recently-viewed');
            el.innerHTML = fetched ? fetched.innerHTML : '';
            /* Every viewed product may since have been deleted or unpublished, leaving a row
               with no cards. Show Best-sellers rather than an empty box. */
            if (!el.querySelector('.nzs-bs__card, .card-product')) this.useFallback();
          })
          .catch((error) => {
            /* A failed fetch is not a reason to leave a blank section on the page. */
            this.useFallback();
            console.log(error);
          });
        },
        clearStory() {
          var result = confirm('Are you sure you want to clear your recently viewed products?');
          if (result === true) {
            localStorage.removeItem("recently-viewed");
            this.show = false;
          }
        }
      })
    })
  });
}